<template>
  <div class="sidebar-pinned">
    <Navbar />

    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-bar-chart-2" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Finance Management</h4>
              <small style="opacity: .8;">Overview of wallet, payments, claims and capitations</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Stat Cards ── -->
        <div class="row mb-4">
          <div class="col-md-3 col-sm-6 mb-3">
            <div class="stat-card stat-card--dark">
              <div class="stat-icon">
                <i class="fe fe-credit-card"></i>
              </div>
              <div>
                <p class="stat-label">SafeHaven MFB — {{ wallet.account.accountName }}</p>
                <p class="stat-label mb-1">{{ wallet.account.accountNumber }} <i class="fe fe-copy"></i></p>
                <h3 class="stat-value">
                  <i class="mdi mdi-currency-ngn"></i>{{ wallet.balance.availableBalance | numeral(0, 0) }}
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 mb-3">
            <div class="stat-card stat-card--blue">
              <div class="stat-icon">
                <i class="fe fe-credit-card"></i>
              </div>
              <div>
                <p class="stat-label">Total Payments Made</p>
                <h3 class="stat-value">
                  <i class="mdi mdi-currency-ngn"></i>{{ funds_dashboard.total_amount_paid | numeral(0, 0) }}
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 mb-3">
            <div class="stat-card stat-card--purple">
              <div class="stat-icon">
                <i class="fe fe-database"></i>
              </div>
              <div>
                <p class="stat-label">Claims Payment</p>
                <h3 class="stat-value">
                  <i class="mdi mdi-currency-ngn"></i>{{ funds_dashboard.sum_of_claims_paid | numeral(0, 0) }}
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 mb-3">
            <div class="stat-card stat-card--green">
              <div class="stat-icon">
                <i class="fe fe-users"></i>
              </div>
              <div>
                <p class="stat-label">Monthly Capitation</p>
                <h3 class="stat-value">
                  <i class="mdi mdi-currency-ngn"></i>{{ captitations | numeral(0, 0) }}
                </h3>
              </div>
            </div>
          </div>
        </div>

        <!-- ── Payments Table ── -->
        <div class="card table-card shadow mb-4">
          <div class="d-flex align-items-center px-4 pt-4 pb-3">
            <i class="fe fe-list text-primary mr-2"></i>
            <h6 class="mb-0 font-weight-bold">Summary</h6>
          </div>
          <div class="table-responsive">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th">Date</th>
                  <th class="table-th">Account</th>
                  <th class="table-th">Amount</th>
                  <th class="table-th">Type</th>
                  <th class="table-th">Narration</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="payment in payments.data" v-bind:key="payment.id">
                  <td class="py-2" style="font-size:.85rem;">
                    {{ payment.transactionDate | moment("dddd, MMMM Do YYYY, h:mm:ss a") }}
                  </td>
                  <td class="py-2">
                    {{ payment.account.accountName }} <span class="code-chip">{{ payment.account.accountNumber }}</span>
                  </td>
                  <td class="py-2 font-weight-bold">
                    <i class="mdi mdi-currency-ngn"></i>{{ payment.amount | numeral(0, 0) }}
                  </td>
                  <td class="py-2">
                    <span class="badge badge-soft-success" v-if="payment.type == 'Credit'">
                      <i class="mdi mdi-check-circle mr-1"></i>{{ payment.type }}
                    </span>
                    <span class="badge badge-soft-danger" v-else>
                      {{ payment.type }}
                    </span>
                  </td>
                  <td class="py-2">{{ payment.narration }}</td>
                </tr>
                <tr v-if="!payments.data || !payments.data.length">
                  <td colspan="5" class="text-center py-5 text-muted">
                    <i class="fe fe-inbox" style="font-size:2rem;opacity:0.3;"></i>
                    <p class="mt-2 mb-0">No payments found</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-body pt-2" v-if="payments.total">
            <b-pagination v-model="currentPage" :total-rows="payments.total" :per-page="payments.per_page || 15"
              @input="getPayments"></b-pagination>
          </div>
        </div>

      </div>
    </main>
  </div>
</template>

<script>
import Navbar from "@/views/Navbar.vue";

export default {
  components: {
    Navbar,
  },
  data() {
    return {
      captitations: 0,
      funds_dashboard: "",
      payments: "",
      user: null,
      currentPage: 1,
      wallet: {
        account: "",
        balance: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    getPaymentAgency() {
      this.axios
        .get(`/api/v1/auth/wallet/transactions/6871a29c5d903780312c2b5b`, {
          params: {
            type: "claims",
          },
        })
        .then((response) => {
          this.payments = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getPaymentProvider() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/paymentorder-provider/${this.user.id}`)
        .then((response) => {
          this.payments = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getDashboardAgency() {
      this.axios
        .get(`/api/v1/auth/finance-dashboard-agency/90`)
        .then((response) => {
          this.funds_dashboard = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getDashboardProvider() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/finance-dashboard-provider/${this.user.id}`)
        .then((response) => {
          this.funds_dashboard = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getPayments() {
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user.type == "employee" || this.user.type == "shis") {
        this.getPaymentAgency();
      } else {
        this.getPaymentProvider();
      }
    },

    getDashboard() {
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user.type == "employee" || this.user.type == "shis") {
        this.getDashboardAgency();
      } else {
        this.getDashboardProvider();
      }
    },

    getWallet() {
      this.isLoading = true;
      this.axios
        .get(`/api/v1/auth/wallet/6871a29c5d903780312c2b5b`)
        .then((response) => {
          console.log(response);
          this.wallet = response.data.data;
          this.$toasted.success("Wallet Fetched", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Error!", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getPayments();
    this.getDashboard();
    this.getWallet();
  },
};
</script>
<style scoped>
  .page-header {
    background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
    padding-bottom: 60px;
  }

  .header-icon-wrap {
    width: 52px;
    height: 52px;
    background: rgba(255, 255, 255, 0.18);
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  /* ── Stat Cards ── */
  .stat-card {
    display: flex;
    align-items: center;
    gap: 18px;
    border-radius: 14px;
    padding: 22px 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, .08);
    color: #fff;
    height: 100%;
  }
  .stat-card--dark { background: linear-gradient(135deg, #0f172a, #334155); }
  .stat-card--blue { background: linear-gradient(135deg, #1e3a5f, #2563eb); }
  .stat-card--purple { background: linear-gradient(135deg, #4c1d95, #7c3aed); }
  .stat-card--green { background: linear-gradient(135deg, #065f46, #10b981); }
  .stat-icon {
    width: 52px;
    height: 52px;
    border-radius: 12px;
    background: rgba(255, 255, 255, .2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
  }
  .stat-label {
    margin: 0;
    font-size: .78rem;
    text-transform: uppercase;
    letter-spacing: .05em;
    opacity: .85;
  }
  .stat-value {
    margin: 2px 0 0;
    font-weight: 700;
  }

  .table-card {
    border-radius: 14px !important;
    border: none !important;
    overflow: hidden;
  }

  .table-head {
    background: #f8fafc;
  }

  .table-th {
    font-size: 0.75rem !important;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #64748b !important;
    font-weight: 600 !important;
    border-bottom: 2px solid #e2e8f0 !important;
    padding: 12px 16px !important;
    white-space: nowrap;
  }

  .table-row {
    border-color: #f1f5f9 !important;
    transition: background 0.15s;
  }

  .table-row:hover {
    background: #f8fafc !important;
  }

  .code-chip {
    display: inline-block;
    background: #eff6ff;
    color: #2563eb;
    font-size: 0.78rem;
    padding: 2px 8px;
    border-radius: 6px;
    font-family: monospace;
  }
</style>
